import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaTiktok,
  FaYoutube,
  FaWhatsapp
} from 'react-icons/fa';

import logo from '../Assets/Images/remesalogo.png';
import slogan from '../Assets/Images/sloganremesa.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-left">
        <img src={logo} alt="Remesa Logo" className="footer-logo" />
        <img src={slogan} alt="Remesa Slogan" className="footer-slogan" />
      </div>

      <div className="footer-center">
        <ul className="footer-links">
          <li><Link className="linkFooter" to="/Cookies">Cookies</Link></li>
          <li><Link className="linkFooter" to="/Privacy">Privacidad</Link></li>
          <li><Link className="linkFooter" to="/Faqs">Faqs</Link></li>
          <li><a className="linkFooter" href="https://wa.me/+34722850962" target="_blank" rel="noopener noreferrer">Contacto</a></li>
        </ul>
      </div>

      <div className="footer-right">
        <div className="social-icons">
          <a href="https://facebook.com/remesaespana" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
          <a href="https://instagram.com/remesaespana" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://twitter.com/remesaespana" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
          <a href="https://tiktok.com/@remesaespana" target="_blank" rel="noopener noreferrer"><FaTiktok /></a>
          <a href="https://youtube.com/@remesaespana" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          <a href="https://wa.me/+34722850962" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
        </div>
      </div>
    </footer>
  );
}

export { Footer };
